export default __webpack_public_path__ + "static/media/logoutIcon.d1a55458.png";